export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-5.b3c7d597.jpg";